import {useEffect} from 'react';
import ReactModal from 'react-modal';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {AlertLineIcon} from '~library/svg/AlertLineIcon';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';
import './MediaUploadModal.sass';

type ModalProps = {
  ctaButtonText: string;
  description: string;
  header: string;
  hideModal: () => void;
  appElement?: string;
};

export const MediaUploadModal = ({
  hideModal,
  header,
  description,
  ctaButtonText,
  appElement = '[data-modal-root]',
}: ModalProps) => {
  useEffect(() => {
    ReactModal.setAppElement(appElement);
  }, [appElement]);
  return (
    <ReactModal
      isOpen
      onRequestClose={hideModal}
      className="media-upload-modal"
      overlayClassName="media-upload-modal--overlay"
    >
      <div className="media-upload-modal--header">
        <div className="media-upload-modal--header-container">
          <AlertLineIcon ratio={0.75} color="red" />
          <Typography variant="header5" className="media-upload-modal--header--text">
            Error: {header}
          </Typography>
        </div>
        <Button
          data-qa-id="close-modal"
          variant="transparent"
          icon={<CloseLineIcon ratio={0.75} color="black" />}
          onClick={hideModal}
        />
      </div>
      <Typography variant="paragraph2" className="media-upload-modal--description">
        {description}
      </Typography>
      <Button className="media-upload-modal--cta" data-qa-id="modal-action" onClick={hideModal}>
        {ctaButtonText}
      </Button>
    </ReactModal>
  );
};
